import React from 'react'
import { string, shape } from 'prop-types'
import * as cmsComponents from 'components/cms/config'
import { getPageName } from 'services/utility'
import CMS from 'components/cms'

const ContentPage = (props) => {
  const getClassName = () => {
    const { pathname } = props.location
    const path = pathname === '/' ? 'home-page' : null
    // set the page name as class name for the root level div.
    return getPageName(' ', path) || props.className
  }

  return (
    <CMS
      {...props}
      className={getClassName()}
      cmsComponents={cmsComponents}
    />
  )
}

ContentPage.propTypes = {
  location: shape({}),
  className: string,
}

ContentPage.defaultProps = {
  location: '',
  className: '',
}

export default ContentPage



// WEBPACK FOOTER //
// ./scenes/content-page/index.js